const Pdf = (function () {
    const orderBtn = document.querySelector('.intro__btn');

    const showPdf = (e) => {
        e.preventDefault();
        window.open('data/example.pdf', '_blank');
    }

    const init = () => {
        orderBtn && orderBtn.addEventListener('click', showPdf);
    };

    return {
        init
    };
})();

export default Pdf;